const BaseUrl = 'https://rss-reader-backend.lban.workers.dev/';
// const BaseUrl = 'http://127.0.0.1:8787/';

export {
  BaseUrl
}